<template>
    <MiniModalCustom :is-open="state.isOpen">
        <div class="text-[20px] font-bold mt-4">Terms of Use</div>
        <div class="mt-4">
            To continue using the clipboardnation.com service, please agree to
            our terms of use below.
        </div>

        <div class="flex mt-4 gap-2 items-center">
            <input
                v-model="state.isChecked"
                type="checkbox"
                name="search_column"
                value="title"
                id="agree"
                class="checked:bg-blue-500 w-5 h-5"
            />

            <div>
                <span @click="state.isChecked = !state.isChecked"
                    >I accept and agree to the</span
                >
                <a class="underline ml-1" :href="props.termLink">Terms of Use</a
                >.
            </div>
        </div>
        <button
            class="
                mt-8
                w-full
                rounded-full
                bg-gradient-to-br
                py-2
                px-6
                from-gray-200
                to-gray-300
                text-white
                p-1
            "
            :class="{
                '!from-primary !to-primaryLight': state.isChecked,
            }"
            :disabled="!state.isChecked"
            @click="agreeTos"
        >
            Continue
        </button>
    </MiniModalCustom>
</template>

<script setup>
import { reactive, defineProps } from "vue";

const props = defineProps({
    termLink: String,
});

const state = reactive({
    isChecked: false,
    isOpen: true,
});

async function agreeTos() {
    await axios.post("/user-agree-tos");
    state.isOpen = false;
}
</script>
